// extracted by mini-css-extract-plugin
module.exports = {"root":"InlineLink_root__1uWKY","dark":"InlineLink_dark__2r4wD"};